// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__aSrje","cardImg":"Card_cardImg__7mJVy","cardId":"Card_cardId__f+UES"};